import { Sheet, SheetContent, SheetDescription, SheetTitle } from "@/components/ui/sheet";
import { useMenu } from "@/context/MenuProvider";
import { Navigation } from "./Navigation";
import { Button } from "@/components/ui/button";
import { Cross2Icon } from "@radix-ui/react-icons";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";

interface MobileNavigationProps {
  isAriaHidden: boolean;
}

export function MobileNavigation({ isAriaHidden }: MobileNavigationProps) {
  const { isOpen, closeMenu } = useMenu();

  return (
    <Sheet open={isOpen}>
      <SheetContent
        role="menu"
        side="left"
        onInteractOutside={closeMenu}
        className="p-0"
        aria-describedby="navigation"
        aria-hidden={isAriaHidden}>
        <Navigation className="relative" isAriaHidden={isAriaHidden} />
        <VisuallyHidden>
          <SheetTitle>Menu</SheetTitle>
          <SheetDescription>Greenlare navigation menu</SheetDescription>
        </VisuallyHidden>
        <Button
          onClick={closeMenu}
          variant="ghost"
          className="absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-secondary">
          <Cross2Icon className="h-4 w-4" />
        </Button>
      </SheetContent>
    </Sheet>
  );
}
